module.exports = __webpack_public_path__ + "static/media/eng-flag.f5d6a450.png";